import {Main} from 'grommet'
import {PropsWithChildren} from 'react'

export default function CenteredMain({children}: PropsWithChildren<{}>) {
  return (
    <Main
      gridArea="main"
      align="center"
      justify="center"
      background={{color: 'white'}}
      pad={{vertical: 'small', horizontal: 'medium'}}
      round={false}
    >
      {children}
    </Main>
  )
}
